import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { CityStateModel, CreditCardEncriptionModel, PaymentDeiails, cardInfo, practiceDetails } from 'src/app/models/registeration/payment_models';
import { PaymentService } from 'src/app/services/payment.service';
declare var $: any;
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  currentDate: Date = new Date();
  currentMonth: string;
  amountDueTemp: Number;
  currentYear: any;
  patientpersonalinfo: any;
  emailStr: String = '';
  isNewPatient: boolean = false;
  practicedetails: practiceDetails = new practiceDetails();
  appointmentId: any;
  isExistingcard: boolean = false;
  cardInfo: cardInfo[] = [];
  amount: any;
  months: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  years: number[] = [];
  cardType: any;
  saveCard: any = "false";
  cardId: any
  cardToken: any;
  providerCode: any = '';
  paymentType: any = '';
  isRTL: boolean = false;
  constructor(private translateService: TranslateService, private activatedRoute: ActivatedRoute, private phrUtils: PhrutillsService, private spinner: NgxSpinnerService,
    private service: PaymentService, private _router: Router, private _location: Location) {
    let info = localStorage.getItem('PatientInfo');
    if (!info) {
      this._router.navigateByUrl("/home?practice_code=''");
      return;
    }
    this.patientpersonalinfo = this.phrUtils.decrypt(localStorage.getItem('PatientInfo'));
    this.emailStr = this.patientpersonalinfo.email_Address;
    //expiry date must not be less than current year
    this.currentYear = this.currentDate.getFullYear();
    this.currentMonth = (this.currentDate.getMonth() + 1).toString();

    //current month needed for expiry 
    if (this.currentMonth.length == 1) {
      this.currentMonth = '0' + this.currentMonth;
    }
    //reset/rebuild form on page load
    this.reset();
    //this.activatedRoute.queryParams.subscribe((param: any)  => {
    //  if(param.NewPatient && param.NewPatient == 'yes'){
    //    this.isNewPatient = true;
    //  }
    //  else {
    //    const apptid = localStorage.getItem("apptId")
    //    if (apptid == null || apptid == undefined || apptid == '') {
    //      this.appointmentId = '';
    //    } else {
    //      this.appointmentId = apptid;
    //    }
    //    this.getPaymentDetails();
    //  }
    //});
  }


  ngOnInit(): void {

    this.getPracticeDetails();
    //this.getExistingCardDeatils();
    const amt = localStorage.getItem("amt");
    this.amount = amt;
    this.paymentForm.controls['amount'].setValue(this.amount);
    this.populateYears();
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.isRTL = false;
        this.phrUtils.setTitle('Pagar el saldo adeudado');
      } else if (language === 'hi') {
        this.isRTL = false;
        this.phrUtils.setTitle('बकाया राशि का भुगतान करें');
      } else if (language === 'ur') {
        this.isRTL = true;
        this.phrUtils.setTitle('بقایا بیلنس ادا کریں');
      }
      else {
        this.isRTL = false;
        this.phrUtils.setTitle('Pay Due Balance');
      }
    });
    const apptid = localStorage.getItem("apptId")
    // console.log("appointment id  ", apptid);
    if (apptid == null || apptid == undefined || apptid == '') {
      this.appointmentId = '';
    } else {
      this.appointmentId = apptid;
      // console.log("inside appointment id  ", apptid);
    }
    const providerCode = localStorage.getItem("prcode")
    // console.log("provider code ", providerCode);
    if (providerCode == null || providerCode == undefined || providerCode == '') {
      this.providerCode = '';
    } else {
      this.providerCode = providerCode;
      //  console.log("inside provider code ", providerCode);
    }
    const ptype = localStorage.getItem("pType");
    if (ptype == 'undefined' || ptype == null || ptype == undefined) {
      this.paymentType = '';
      console.log("inside ", this.paymentType)
    } else {
      this.paymentType = ptype;

    }
    this.getPaymentDetails();
  }

  populateYears(): void {
    const currentYear = new Date().getFullYear();
    const endYear = currentYear + 15;

    this.years = []; // Initialize or reset the years array

    for (let i = currentYear; i <= endYear; i++) {
      this.years.push(i);
    }
  }
  onFinishIntake() {
    /*
    this.paymentForm.markAllAsTouched();
    if (this.paymentForm.invalid) {
      localStorage.setItem("noIntakeForm", "true");
      this._router.navigateByUrl('patient/thank-you');
    } else {
      this.onSubmitPayment();
    } */
    //$('#leavePayment-modal').modal('show');

    //localStorage.setItem("noIntakeForm", "true");
    // this._router.navigateByUrl('patient/thank-you');

    //restrict user to pay
    this.onSubmitPayment();
  }
  onFinish() {
    localStorage.setItem("noIntakeForm", "true");
    this._router.navigateByUrl('/thank-you');
  }
  onCardNumberInput(event: any) {
    const input = event.target;
    let inputValue = input.value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = inputValue.match(/\d{4,16}/g);
    const match = matches && matches[0] || '';
    const parts = [];

    for (let i = 0; i < match.length; i += 4) {
      parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
      input.value = parts.join(' ');
    } else {
      input.value = inputValue;
    }

    this.paymentForm.controls['ccn'].setValue(input.value.replace(/\s+/g, ''));
  }
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  // get payment details of patient (page load)
  getPaymentDetails() {
    this.spinner.show();
    this.service.getPaymentDetailsOld(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data) {
        this.paymentDetials = res as PaymentDeiails;
        this.amountDueTemp = Number(this.paymentDetials.data.amT_DUE);
        this.paymentDetials.data.amT_DUE = Number(this.paymentDetials.data.amT_DUE).toFixed(2).toLocaleString();
        if (Number(this.paymentDetials.data.totalAmount) <= 0) {
          this._location.back();
          return;
        }
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }

  practiceAddressTrimmed: any;
  masked_cellPhone: any;
  getPracticeDetails() {

    this.spinner.show();
    this.service.getPracticeDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.statusCode == 200) {
        this.practicedetails = res.data as practiceDetails;
        this.practiceAddressTrimmed = this.practicedetails.practiceAddress.split(',');

        // Masking for cellphone no in payment receipt
        let phoneNumDigits = this.practicedetails.practicePhone;
        var formattedNumber = phoneNumDigits;
        if (phoneNumDigits.length >= 7)
          formattedNumber = '(' + phoneNumDigits.substring(0, 3) + ') ' + phoneNumDigits.substring(3, 6) + '-' + phoneNumDigits.substring(6);
        else if (phoneNumDigits.length >= 4)
          formattedNumber = '(' + phoneNumDigits.substring(0, 3) + ') ' + phoneNumDigits.substring(3);
        this.masked_cellPhone = formattedNumber;

      }
    }
      //  , (error: any) => {
      //   this.spinner.hide();
      //   this.phrUtils.showError("Service is not available, please try later.");
      // }
    );

  }
  successPayment() {
    $('#emailsuccess').modal('show');
  }
  //reset form and rebuild (if page loads/reloads)
  reset() {
    this.paymentForm.reset();
    this.buildpaymentForm();
    this.paymentForm.controls["firstname"].setValue(this.toTitleCase(this.patientpersonalinfo.first_Name));
    this.paymentForm.controls["lastname"].setValue(this.toTitleCase(this.patientpersonalinfo.last_Name));
    //this.paymentForm.controls["firstname"].setValue(this.patientpersonalinfo.first_Name);
    //this.paymentForm.controls["lastname"].setValue(this.patientpersonalinfo.last_Name);
    // this.paymentForm.controls["cell"].setValue(this.patientpersonalinfo.cell_phone);
  }
  // make Names to titlecase
  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/(?:^|\s|-|')(?:\w)/g, match => match.toUpperCase());
  }

  //create payment form
  paymentForm: FormGroup = new FormGroup({});
  //buildpaymentForm(){
  //  this.paymentForm  = new FormGroup({
  //    firstname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
  //    lastname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
  //    amount: new FormControl('', [Validators.required, Validators.max(4999)]),
  //    ccn: new FormControl('', [Validators.required, Validators.maxLength(19), Validators.minLength(8)]),
  //    cvv: new FormControl('', [Validators.required, Validators.maxLength(4), Validators.minLength(3)]),
  //    expirydate: new FormControl(this.currentYear+'-'+this.currentMonth, Validators.required),
  //    cell: new FormControl('', [Validators.required, Validators.maxLength(14)]),
  //    addressl1: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  //    addressl2: new FormControl('', Validators.maxLength(27)),
  //    zip: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(5)]),
  //    city: new FormControl('', Validators.required),
  //    state: new FormControl('', Validators.required),
  //  });
  //}
  buildpaymentForm() {
    this.paymentForm = new FormGroup({
      firstname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
      lastname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
      nameOnCard: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
      amount: new FormControl('', [Validators.required, Validators.max(4999)]),
      ccn: new FormControl('', [Validators.required, Validators.maxLength(19), Validators.minLength(8)]),
      cvv: new FormControl('', [Validators.required, Validators.maxLength(4), Validators.minLength(3)]),
      expirydate: new FormControl(this.currentYear + '-' + this.currentMonth, Validators.required),
      dobMonth: new FormControl('', [Validators.required]),
      dobyear: new FormControl('', [Validators.required]),
      cell: new FormControl(''),
      addressl1: new FormControl(''),
      addressl2: new FormControl(''),
      zip: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),

    });
  }

  //get payment form controls for validations/manipulations
  get getpaymentForm() {
    return this.paymentForm.controls;
  }
  onClickBack() {
    this._router.navigateByUrl("/payment-overview");
  }

  //payment form being submitted/validated
  ObjPayment: any = {};
  PaymentResponse: any = null;
  onSubmitPayment() {
    //make form fields touched to show errors if they are invalid, return
    this.paymentForm.markAllAsTouched();
    if (this.paymentForm.invalid) {
      console.log("Payment Form invalid" + this.paymentForm)
      return;
    }
    //date 2022-05
    let expDtae = this.getpaymentForm['expirydate'].value;
    this.ObjPayment['paymenT_MERCHANT_ID'] = '';
    this.ObjPayment['patientaccount'] = this.patientpersonalinfo.patient_Account;
    this.ObjPayment['practicecode'] = this.patientpersonalinfo.practice_Code;
    //this.ObjPayment['firstname'] = this.getpaymentForm['firstname'].value;
    this.ObjPayment['firstname'] = '';
    /*this.ObjPayment['lastname'] = this.getpaymentForm['lastname'].value;*/
    /*this.ObjPayment['lastname'] = this.isExistingcard ? this.cardHolderName : this.getpaymentForm['nameOnCard'].value;*/
    this.ObjPayment['lastname'] =  this.getpaymentForm['nameOnCard'].value;
    this.ObjPayment['paidamountbycc'] = this.getpaymentForm['amount'].value;
    this.ObjPayment['cradittype'] = this.creditCType.toLowerCase().includes('visa') ? 'Visa' : this.creditCType.toLowerCase().includes('discover') ? 'Discover' : this.creditCType.toLowerCase().includes('amercan') ? 'American Express' : this.creditCType.toLowerCase().includes('mastercard') ? 'Master Card' : '';
    this.ObjPayment['cvn'] = this.getpaymentForm['cvv'].value;
    this.ObjPayment['expirydate'] = expDtae.split('-')[1] + '/' + expDtae.split('-')[0];
    this.ObjPayment['expmonth'] = expDtae.split('-')[1];
    this.ObjPayment['expyear'] = expDtae.split('-')[0];
    this.ObjPayment['address'] = this.getpaymentForm['addressl1'].value + ' ' + this.getpaymentForm['addressl2'].value;
    this.ObjPayment['cell'] = this.getpaymentForm['cell'].value;
    this.ObjPayment['zip'] = this.getpaymentForm['zip'].value;
    //if (this.ObjPayment['zip'].length == 10){
    //  this.ObjPayment['zip'] = this.ObjPayment['zip'].substring(0, 5) + this.ObjPayment['zip'].substring(6, 10);
    //}
    //else if (this.ObjPayment['zip'].length < 10 && this.ObjPayment['zip'].length > 4){
    //  this.ObjPayment['zip'] = this.ObjPayment['zip'].substring(0, 5);
    //}
    this.ObjPayment['city'] = this.getpaymentForm['city'].value;
    this.ObjPayment['state'] = this.getpaymentForm['state'].value;
    this.ObjPayment['amountdue'] = this.paymentDetials.data.amT_DUE;
    this.ObjPayment['billingadd'] = '';
    this.ObjPayment['prevBalance'] = this.paymentDetials.data.amT_DUE;
    this.ObjPayment['prevBalance'] = this.paymentDetials.data.amT_DUE;
    this.ObjPayment['copay'] = this.paymentDetials.data.currentDayAmount;
    this.ObjPayment['totalBalance'] = this.paymentDetials.data.totalAmount;
    if (this.ObjPayment['creditcrdnumber'] == "") {
      return;
    }
    if (this.ObjPayment['paidamountbycc'] <= 0) {
      let text = "Amount Should be greater than $0.";
      this.translateService.get('Alerts.ammount_greater_than').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showInfo(text);
      //this.phrUtils.showInfo('Amount Should be greater than $0.');
      return;
    }
    if (this.ObjPayment['cvn'] < 1) {
      let text = "Enter correct CVV number.";
      this.translateService.get('Alerts.enter_correct_cvv').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showInfo(text);
      //this.phrUtils.showInfo('Enter correct CVV number.');
      return;
    }
    //show spinner loader. Send form to api
    this.spinner.show();
    this.service.submitPayment(this.ObjPayment).subscribe((res: any) => {
      this.spinner.hide();
      //if result is not null, show success and show reciept.
      if (res) {
        if (res.statusCode == 200 && res.message.toLowerCase() == 'success' && res.data[0] != null) {
          if (res.data[0].transactionID != null || res.data[0].displayMessage.toLowerCase().includes('Transaction Successful')) {

            // receipt object to show/bind on receipt
            this.PaymentResponse = res.data[0];
            this.PaymentResponse['firstname'] = this.getpaymentForm['firstname'].value;
            this.PaymentResponse['lastname'] = this.getpaymentForm['lastname'].value;
            this.PaymentResponse['ccn'] = this.getpaymentForm['ccn'].value.substring(this.getpaymentForm['ccn'].value.length - 4, this.getpaymentForm['ccn'].value.length);
            this.PaymentResponse['amount'] = this.getpaymentForm['amount'].value;
            let text = "Transaction Successful";
            this.translateService.get('paymentPage.transaction_successful').subscribe((translation: string) => {
              text = translation;
            });
            this.phrUtils.showSuccess(text);
            //this.phrUtils.showSuccess(res.data[0].displayMessage);
            if (this.isExistingcard == true && this.iscardSelected == false) {
              let text = "Please select card";
              this.translateService.get('Alerts.selectCard').subscribe((translation: string) => {
                text = translation;
              });
              this.phrUtils.showWarning(text);
              return;
            }
            // send sms upon payment pending on backend as there are query params and no bodyy for post
            // { lastName, firstName, cellPhone, amount, creditCardNumber, }
            // this.objSMS['lastName'] = this.PaymentResponse['lastname'];
            // this.objSMS['firstName'] =  this.PaymentResponse['firstname'];
            // this.objSMS['cellPhone'] = this.paymentForm.controls['phone'].value;
            // this.objSMS['amount'] = this.PaymentResponse['amount'];
            // this.objSMS['creditCardNumber'] = this.PaymentResponse['ccn'];

            // this.sendSMS(this.objSMS);
            //this for email receipt
            this.objEmailReceipt['firstName'] = this.getpaymentForm.firstname.value;
            this.objEmailReceipt['lastName'] = this.getpaymentForm.lastname.value;
            this.objEmailReceipt['response_message'] = this.PaymentResponse.response_message;
            this.objEmailReceipt['response_Code'] = this.PaymentResponse.response_code;
            this.objEmailReceipt['cardType'] = this.ObjPayment['cradittype'];
            this.objEmailReceipt['creditCardHolderName'] = this.getpaymentForm.firstname.value + ' ' + this.getpaymentForm.lastname.value;
            this.objEmailReceipt['charges'] = this.getpaymentForm.amount.value;
            this.objEmailReceipt['authorizationCode'] = this.PaymentResponse.authCode;
            this.objEmailReceipt['email'] = this.patientpersonalinfo.email_Address;
            this.objEmailReceipt['patient_account'] = this.patientpersonalinfo.patient_Account;
            this.objEmailReceipt['card_number_staric'] = '*******' + this.PaymentResponse.ccn.substring(this.PaymentResponse.ccn - 5, this.PaymentResponse.ccn.length - 1);
            this.objEmailReceipt['practice_code'] = this.patientpersonalinfo.practice_Code;
            //email reciept ends
            this.reset();
          }
          else if (res.message.toLowerCase().includes('active merchant account') && res.data == null) {
            let text = "Your provider does not have an active merchant account. Please contact your Provider.";
            this.translateService.get('Alerts.no_active_merchnat').subscribe((translation: string) => {
              text = translation;
            });
            this.phrUtils.showError(text);
            //this.phrUtils.showError(res.message);
          }
          // {"status":"FAIL*The credit card number is invalid.","displayMessage":"The credit card number is invalid.","transactionID":null,"authCode":null,
          // "response_code":null,"response_message":null}
          else if (res.data[0].status.toLowerCase().includes('credit card number is invalid')) {
            let text = "The credit card number is invalid.";
            this.translateService.get('Alerts.credit_card_number_invalid').subscribe((translation: string) => {
              text = translation;
            });
            this.phrUtils.showError(text);
            //this.phrUtils.showError('The credit card number is invalid.');
          }
          // {"status":"FAIL*The credit card has expired.","displayMessage":"The credit card has expired.",
          else if (res.data[0].status.toLowerCase().includes('credit card has expired')) {
            let text = "The credit card has expired.";
            this.translateService.get('Alerts.credit_card_expired').subscribe((translation: string) => {
              text = translation;
            });
            this.phrUtils.showError(text);
            //this.phrUtils.showError('The credit card has expired.');
          }
          else {
            this.phrUtils.showError(res.data[0].status)
          }
        }
        else if (res.message.toLowerCase().includes('active merchant account') && res.data == null) {
          let text = "Your provider does not have an active merchant account. Please contact your Provider.";
          this.translateService.get('Alerts.no_active_merchnat').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError(res.message);
        }
        else if (res.data[0] != null && res.data[0].status.toLowerCase().includes('something went wrong')) {
          let text = "Something went wrong.";
          this.translateService.get('Alerts.something_went_wrong').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError('Something went wrong.');
        }
        else if (res.data[0] != null && res.data[0].status.toLowerCase().includes('login is incorrect')) {
          this.phrUtils.showError(res.data[0].status);
        }
        else if (res.data[0] != null && res.data[0].displayMessage.toLowerCase().includes('login is incorrect')) {
          this.phrUtils.showError(res.data[0].displayMessage);
        }
        else if (res.message.toLowerCase().includes('login is incorrect')) {
          this.phrUtils.showError(res.message);
        }
        else {
          // this.phrUtils.showError(res.message);
          let text = "An unknown error occured while procesing your request.";
          this.translateService.get('Alerts.unknown_error_occured').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError('An unknown error occured while procesing your request.');
        }
      }
      else {
        let text = "An unknown error occured while procesing your request.";
        this.translateService.get('Alerts.unknown_error_occured').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        // this.phrUtils.showError("An unknown error occured while procesing your request.");
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");

    });
  }


  //onSubmitPayment() {
  //  //make form fields touched to show errors if they are invalid, return
  //  if (this.isExistingcard == false) {
  //    this.paymentForm.markAllAsTouched();
  //    if (this.paymentForm.invalid) {
  //      console.log("is existing card invalid ", this.isExistingcard);
  //      return;
  //    }
  //  }
  //  console.log("is existing card ", this.isExistingcard);
  //  console.log("is card selected ", this.iscardSelected);
  //  if (this.isExistingcard == true && this.iscardSelected == false) {
  //    let text = "Please select card";
  //    this.translateService.get('Alerts.selectCard').subscribe((translation: string) => {
  //      text = translation;
  //    });
  //    this.phrUtils.showWarning(text);
  //    return;
  //  }

  //  //date 2022-05
  //  let expDtae = this.getpaymentForm['expirydate'].value;
  //  this.ObjPayment['paymenT_MERCHANT_ID'] = '';
  //  this.ObjPayment['patientaccount'] = this.patientpersonalinfo.patient_Account;
  //  this.ObjPayment['practicecode'] = this.patientpersonalinfo.practice_Code;
  //  this.ObjPayment['firstname'] = '';
  //  this.ObjPayment['lastname'] = this.isExistingcard ? this.cardHolderName : this.getpaymentForm['nameOnCard'].value;
  //  this.ObjPayment['paidamountbycc'] = this.getpaymentForm['amount'].value;
  //  this.ObjPayment['cradittype'] = this.isExistingcard ? this.creditCardType : this.creditCType.toLowerCase().includes('visa') ? 'Visa' : this.creditCType.toLowerCase().includes('discover') ? 'Discover' : this.creditCType.toLowerCase().includes('amercan') ? 'AMEX' : this.creditCType.toLowerCase().includes('mastercard') ? 'Master Card' : '';
  //  this.ObjPayment['cvn'] = this.isExistingcard ? "" : this.phrUtils.encryptforServices(this.getpaymentForm['cvv'].value);
  //  const dobMonth = this.getpaymentForm['dobMonth'].value;

  //  const dobYear = this.getpaymentForm['dobyear'].value;

  //  const formattedDate = dobMonth + "/" + dobYear;
  //  this.ObjPayment['expirydate'] = formattedDate;
  //  this.ObjPayment['expmonth'] = dobMonth;
  //  this.ObjPayment['expyear'] = dobYear;
  //  this.ObjPayment['address'] = "";
  //  this.ObjPayment['cell'] = "";
  //  this.ObjPayment['zip'] = "";

  //  this.ObjPayment['city'] = "";
  //  this.ObjPayment['state'] = "";
  //  this.ObjPayment['amountdue'] = this.paymentDetials.data.amT_DUE;
  //  this.ObjPayment['billingadd'] = '';
  //  this.ObjPayment['prevBalance'] = this.paymentDetials.data.amT_DUE;
  //  this.ObjPayment['prevBalance'] = this.paymentDetials.data.amT_DUE;
  //  this.ObjPayment['copay'] = this.paymentDetials.data.currentDayAmount;
  //  this.ObjPayment['totalBalance'] = this.paymentDetials.data.totalAmount;
  //  this.ObjPayment['AppointmentId'] = "101116392852764";
  //  this.ObjPayment['ProviderCode'] = "53481719";
  //  this.ObjPayment['PaymentType'] = this.paymentType;
  //  /*    this.ObjPayment['credit_card_id'] = this.isExistingcard ? this.cardId:"";*/
  //  this.ObjPayment['tokenNumber'] = this.isExistingcard ? this.cardToken : "";
  //  this.ObjPayment['savecard'] = this.isExistingcard ? "" : this.saveCard;
  //  this.ObjPayment['type'] = this.isExistingcard ? "existing_card" : "new_card";
  //  this.ObjPayment['creditcrdnumber'] = this.isExistingcard ? "" : this.ObjPayment['creditcrdnumber'];
  //  if (this.isExistingcard == false) {
  //    if (this.ObjPayment['creditcrdnumber'] == "") {
  //      return;
  //    }
  //  }

  //  if (this.ObjPayment['paidamountbycc'] <= 0) {
  //    let text = "Amount Should be greater than $0.";
  //    this.translateService.get('Alerts.ammount_greater_than').subscribe((translation: string) => {
  //      text = translation;
  //    });
  //    this.phrUtils.showInfo(text);
  //    //this.phrUtils.showInfo('Amount Should be greater than $0.');
  //    return;
  //  }
  //  if (this.isExistingcard == false) {
  //    if (this.ObjPayment['cvn'] < 1) {
  //      let text = "Enter correct CVV number.";
  //      this.translateService.get('Alerts.enter_correct_cvv').subscribe((translation: string) => {
  //        text = translation;
  //      });
  //      this.phrUtils.showInfo(text);
  //      //this.phrUtils.showInfo('Enter correct CVV number.');
  //      return;
  //    }
  //  }

  //  //show spinner loader. Send form to api
  //  console.log("payment object ", this.ObjPayment);
  //  //return;
  //  this.spinner.show();
  //  this.service.OnlinePaymentSaveCard(this.ObjPayment).subscribe((res: any) => {
  //    this.spinner.hide();
  //    //if result is not null, show success and show reciept.
  //    if (res) {
  //      if (res.statusCode == 200 && (res.message.toLowerCase() == 'success' || res.message.toLowerCase() == 'sucess') && res.data[0] != null) {
  //        //this.getPaymentDetails();
  //        if (res.data[0].transactionID != null || res.data[0].displayMessage.toLowerCase().includes('Transaction Successful')) {
  //          localStorage.setItem("noIntakeForm", "true");
  //          //this._router.navigateByUrl('thank-you');
  //          //this._router.navigate(['/home'], { queryParams: { practice_code: this.patientpersonalinfo.practice_Code }, replaceUrl: true });
  //          // receipt object to show/bind on receipt

  //          this.PaymentResponse = res.data[0];
  //          this.PaymentResponse['firstname'] = this.getpaymentForm['firstname'].value;
  //          this.PaymentResponse['lastname'] = this.getpaymentForm['lastname'].value;
  //          this.PaymentResponse['nameonCard'] = this.getpaymentForm['nameOnCard'].value;
  //          this.PaymentResponse['ccn'] = this.getpaymentForm['ccn'].value.substring(this.getpaymentForm['ccn'].value.length-4,this.getpaymentForm['ccn'].value.length);
  //          this.PaymentResponse['amount'] = this.getpaymentForm['amount'].value;
  //          let text = "Payment has been processed";
  //          this.translateService.get('paymentPage.transaction_successful').subscribe((translation: string) => {
  //            text = translation;
  //          });
  //          this.phrUtils.showSuccess(text);
  //          //this.phrUtils.showSuccess(res.data[0].displayMessage);

  //          // send sms upon payment pending on backend as there are query params and no bodyy for post
  //          // { lastName, firstName, cellPhone, amount, creditCardNumber, }
  //          // this.objSMS['lastName'] = this.PaymentResponse['lastname'];
  //          // this.objSMS['firstName'] =  this.PaymentResponse['firstname'];
  //          // this.objSMS['cellPhone'] = this.paymentForm.controls['phone'].value;
  //          // this.objSMS['amount'] = this.PaymentResponse['amount'];
  //          // this.objSMS['creditCardNumber'] = this.PaymentResponse['ccn'];

  //          // this.sendSMS(this.objSMS);
  //          //this for email receipt
  //           this.objEmailReceipt['firstName'] = this.getpaymentForm.firstname.value;
  //           this.objEmailReceipt['lastName'] = this.getpaymentForm.lastname.value;
  //           this.objEmailReceipt['response_message'] = this.PaymentResponse.response_message;
  //           this.objEmailReceipt['response_Code'] = this.PaymentResponse.response_code;
  //           this.objEmailReceipt['cardType'] = this.ObjPayment['cradittype'];
  //           this.objEmailReceipt['creditCardHolderName'] = this.getpaymentForm.firstname.value +' ' + this.getpaymentForm.lastname.value;
  //           this.objEmailReceipt['charges'] = this.getpaymentForm.amount.value;
  //           this.objEmailReceipt['authorizationCode'] = this.PaymentResponse.authCode;
  //           this.objEmailReceipt['email'] = this.patientpersonalinfo.EMAIL_ADDRESS;
  //          this.objEmailReceipt['patient_account'] = this.patientpersonalinfo.patient_Account;
  //           this.objEmailReceipt['card_number_staric'] = '*******'+this.PaymentResponse.ccn.substring(this.PaymentResponse.ccn-5, this.PaymentResponse.ccn.length-1);
  //          this.objEmailReceipt['practice_code'] = this.patientpersonalinfo.practice_Code;
  //          //email reciept ends            
  //          this.reset();
  //        }
  //        else if (res.message.toLowerCase().includes('active merchant account') && res.data == null) {
  //          let text = "Your provider does not have an active merchant account. Please contact your Provider.";
  //          this.translateService.get('Alerts.no_active_merchnat').subscribe((translation: string) => {
  //            text = translation;
  //          });
  //          this.phrUtils.showError(text);
  //          //this.phrUtils.showError(res.message);
  //        }

  //        else if (res.data[0].status.toLowerCase().includes('credit card number is invalid')) {
  //          let text = "The credit card number is invalid.";
  //          this.translateService.get('Alerts.credit_card_number_invalid').subscribe((translation: string) => {
  //            text = translation;
  //          });
  //          this.phrUtils.showError(text);
  //          //this.phrUtils.showError('The credit card number is invalid.');
  //        }

  //        else if (res.data[0].status.toLowerCase().includes('credit card has expired')) {
  //          let text = "The credit card has expired.";
  //          this.translateService.get('Alerts.credit_card_expired').subscribe((translation: string) => {
  //            text = translation;
  //          });
  //          this.phrUtils.showError(text);
  //          //this.phrUtils.showError('The credit card has expired.');
  //        }
  //        else {
  //          this.phrUtils.showError(res.data[0].status)
  //        }
  //      }
  //      else if (res.message.toLowerCase().includes('active merchant account') && res.data == null) {
  //        let text = "Your provider does not have an active merchant account. Please contact your Provider.";
  //        this.translateService.get('Alerts.no_active_merchnat').subscribe((translation: string) => {
  //          text = translation;
  //        });
  //        this.phrUtils.showError(text);
  //        //this.phrUtils.showError(res.message);
  //      }
  //      else if (res.data[0] != null && res.data[0].status.toLowerCase().includes('something went wrong')) {
  //        let text = "Something went wrong.";
  //        this.translateService.get('Alerts.something_went_wrong').subscribe((translation: string) => {
  //          text = translation;
  //        });
  //        this.phrUtils.showError(text);
  //        //this.phrUtils.showError('Something went wrong.');
  //      }
  //      else if (res.data[0] != null && res.data[0].status.toLowerCase().includes('login is incorrect')) {
  //        this.phrUtils.showError(res.data[0].status);
  //      }
  //      else if (res.data[0] != null && res.data[0].displayMessage.toLowerCase().includes('login is incorrect')) {
  //        this.phrUtils.showError(res.data[0].displayMessage);
  //      }
  //      else if (res.message.toLowerCase().includes('login is incorrect')) {
  //        this.phrUtils.showError(res.message);
  //      }
  //      else {
  //        // this.phrUtils.showError(res.message);
  //        let text = "An unknown error occured while procesing your request.";
  //        this.translateService.get('Alerts.unknown_error_occured').subscribe((translation: string) => {
  //          text = translation;
  //        });
  //        this.phrUtils.showError(text);
  //        //this.phrUtils.showError('An unknown error occured while procesing your request.');
  //      }
  //    }
  //    else {
  //      let text = "An unknown error occured while procesing your request.";
  //      this.translateService.get('Alerts.unknown_error_occured').subscribe((translation: string) => {
  //        text = translation;
  //      });
  //      this.phrUtils.showError(text);
  //      // this.phrUtils.showError("An unknown error occured while procesing your request.");
  //    }
  //  }, (error: any) => {
  //    this.spinner.hide();
  //    let text = "Service is not available, please try later.";
  //    this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
  //      text = translation;
  //    });
  //    this.phrUtils.showError(text);
  //    //this.phrUtils.showError("Service is not available, please try later.");

  //  });
  //}

  getExistingCardDeatils() {
    this.spinner.show();
    this.service.getExistingCreditCradDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.statusCode == 200 && res.message == 'Success' && res.data) {
        if (res.data.length > 0)
          this.isExistingcard = true;
        else
          this.isExistingcard = false;
        // this.cardInfo = res.data as cardInfo[];

        this.cardInfo = this.decryptCardData(res.data as cardInfo[]);

        console.log("is existing card ", this.isExistingcard);
        console.log("card details ", this.cardInfo);
      } else {
        this.isExistingcard = false;
        console.log("is existing card ", this.isExistingcard);
      }
    }, (error: any) => {
      this.isExistingcard = false;
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
    })
  }

  decryptCardData(encryptedData: any[]): any[] {
    return encryptedData.map(card => ({
      credit_card_id: this.phrUtils.decryptforServices(card.credit_card_id),
      credit_card_name: this.phrUtils.decryptforServices(card.credit_card_name),
      token_number: this.phrUtils.decryptforServices(card.token_number),
      expiration_month: this.phrUtils.decryptforServices(card.expiration_month),
      expiration_year: this.phrUtils.decryptforServices(card.expiration_year),
      card_type: this.phrUtils.decryptforServices(card.card_type)
    }));
  }

  //get cities and states upon zip number
  cityStateList: CityStateModel[] = [];
  getZipCityState(e: any) {
    let v = e.target.value;
    if (v.length < 5) {
      return;
    }
    this.spinner.show();
    this.service.getCityStateViaZip(v, this.patientpersonalinfo.patient_Account, this.patientpersonalinfo.practice_Code).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200 && res.data.length > 0) {
        this.cityStateList = res.data as CityStateModel[];
        this.getpaymentForm["city"].setValue(this.cityStateList[0].cityName);
        this.getpaymentForm["state"].setValue(this.cityStateList[0].stateCode);
      }
      else if (res.statusCode == 404) {
        this.getpaymentForm["zip"].setErrors({ invalid: true, required: true });
        this.removeStateCity();
      }
      else {
        this.getpaymentForm["zip"].setErrors({ invalid: true, required: true });
        this.removeStateCity();
      }
    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        // this.phrUtils.showError("Service is not available, please try later. "+error);
      });
  }

  // select a state upon city name selection
  showState(e: any) {
    let c = e.target.value;
    this.cityStateList.map(city => {
      if (city.cityName === c) {
        this.paymentForm.controls["state"].setValue(city.stateCode);
      }
    });
  }

  // clear both city and state dropdowns if zip not found or zip length not valid 
  removeStateCity() {
    this.cityStateList = [];
    this.cityStateList.length = 0;
    this.getpaymentForm["city"].setValue('');
    this.getpaymentForm["state"].setValue('');
  }

  // only show numbers in credit card and cvc fields
  onlyNumberAllow(e: any): boolean {
    e.target.value = e.target.value.replace(/\D/g, '');
    e.target.value = this.phrUtils.maskingZipNum(e.target.value);
    if (e.target.value.length == 10 || e.target.value.length == 5) {
      this.getZipCityState(e);
      return false;
    }
    if (e.target.value.length < 5 || e.target.value.length < 10) {
      this.removeStateCity();
    }

    const charCode = (e.which) ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    else {
      return true;
    }
  }

  // validate any number with digit limit
  validateNumber(e: any, limit: number): boolean {
    let val = e.target.value.replace(/\D/g, '');
    e.target.value = val.replace(/\s/g, '');
    if (limit == val.length) {
      return false;
    }
    const charCode = (e.which) ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    else {
      return true;
    }
  }
  validatenameonCard(e: any, controlName: string) {
    // Allow letters (a-z, A-Z), spaces, hyphens, and apostrophes
    let val = e.target.value.replace(/[^a-zA-Z\s'-]/g, "");

    // Update the input value and form control
    e.target.value = val;
    this.paymentForm.controls[controlName].setValue(val);
  }

  // credit card type and show matched card image icon in field 
  creditCType: String = "";
  checkCCT(e: any) {
    let ccn = e.target.value.replace(/\D/g, '');
    e.target.value = ccn.replace(/\s/g, '');
    if (ccn.length >= 4) {
      this.getpaymentForm['ccn'].markAsTouched();
    }
    if (ccn.match('^4[0-9]{12}(?:[0-9]{3})?$')) {
      this.creditCType = "assets/images/payment/visa.png";
      this.ObjPayment['creditcrdnumber'] = this.phrUtils.encryptforServices(ccn);
    }
    else if (ccn.match('^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$')) {
      this.creditCType = "assets/images/payment/mastercard.png";
      this.ObjPayment['creditcrdnumber'] = this.phrUtils.encryptforServices(ccn);
    }
    else if (ccn.match('^3[47][0-9]{13}$')) {
      this.creditCType = "assets/images/payment/amercan.png";
      this.ObjPayment['creditcrdnumber'] = this.phrUtils.encryptforServices(ccn);
    }
    else if (ccn.match('^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$')) {
      this.creditCType = "assets/images/payment/discover.png";
      this.ObjPayment['creditcrdnumber'] = this.phrUtils.encryptforServices(ccn);
    }
    else {
      this.creditCType = "";
      this.ObjPayment['creditcrdnumber'] = "";
      this.paymentForm.controls.ccn.markAsTouched;
      this.paymentForm.controls.ccn.setErrors({ invalidNumber: true });
    }
  }

  validateCurreny(e: any): boolean {

    let curr = e.target.value;
    let dotExists = curr.indexOf('.') > -1 ? true : false;
    if (e.keyCode > 47 && e.keyCode < 58) {
      if (dotExists && curr.length == (curr.indexOf('.') + 3)) {
        return false;
      }
      else if (dotExists && curr.length < (curr.indexOf('.') + 3)) {
        return true;
      }
      if (Number(curr + e.key) <= 9999.99) {
        return true;
      }
      return false;
    }
    else if (e.keyCode === 46) {
      if (dotExists) {
        return false;
      }
      return true;
    }
    // else if(!this.isNewPatient && Number(curr + e.key ) > Number(this.paymentDetials.data.amT_DUE)){
    //   return true;
    // }
    else {
      return false;
    }
  }

  // validateCurrenyChange(e: any){
  //   let regexp = new RegExp(/^\d*\.?\d*$/);
  //   let v = e.target.value;
  //   // let isValid = regexp.test(v);
  //   // if(!isValid){
  //   //   this.paymentForm.controls["amount"].setErrors({'invalidinput': true});
  //   //   return;
  //   // }

  //   // v = e.target.value = Number(e.target.value).toFixed(2);
  //   // if(v > 4999){
  //   //   this.paymentForm.controls["amount"].setErrors({'max': true});
  //   //   return;
  //   // }
  //   if(!this.isNewPatient && v > Number(this.paymentDetials.data.amT_DUE)){
  //     this.paymentForm.controls["amount"].setErrors({'greaterThanTotalDues': true});
  //   }
  // }

  // mask phone number
  validatePhoneNo(e: any) {
    let phoneNumDigits = e.target.value.replace(/\D/g, '');
    e.target.value = phoneNumDigits;
    var formattedNumber = phoneNumDigits;
    if (phoneNumDigits.length >= 7)
      formattedNumber = '(' + phoneNumDigits.substring(0, 3) + ') ' + phoneNumDigits.substring(3, 6) + '-' + phoneNumDigits.substring(6);
    else if (phoneNumDigits.length >= 4)
      formattedNumber = '(' + phoneNumDigits.substring(0, 3) + ') ' + phoneNumDigits.substring(3);
    e.target.value = formattedNumber;
  }

  // validate phone number
  validateName(e: any, controlName: string) {
    let val = e.target.value.replace(/[^a-zA-Z]/g, "");
    e.target.value = val;
    this.paymentForm.controls[controlName].setValue(e.target.value)
  }


  objEmailReceipt: any = {};
  emailSent: boolean = false;
  sendReceiptEmail() {
    if (!this.valEmail(this.objEmailReceipt['email'])) {
      this.emError = true;
      return;
    }
    this.emError = false;
    this.spinner.show();
    this.service.sendEmailReceipt(this.objEmailReceipt).subscribe((res: any) => {
      this.spinner.hide();
      // {"statusCode":200,"message":"Success","data":null}
      if (res.statusCode == 200 && res.message == 'Success') {
        $('#emailsuccess').modal('show');
        this.emailSent = true;
      }
    }, (error: any) => {
      this.spinner.hide();
      console.log('sendReceiptEmail: error. ' + error);
    });
  }

  // sms payment verification
  objSMS: any = null;
  sendSMS(objSms: any) {
    if (objSms == '{}') {
      return;
    }
    this.service.sendSMS(this.objSMS).subscribe((res: any) => {
      console.log('Sms sent successfully.');
    }, (error: any) => {
      console.log('Failed');
    });
  }

  //validate email
  emError = false;
  valEmail(email: any) {
    let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return regexp.test(email);
  }

  finishClicked() {
    this._router.navigate(['/home'], { queryParams: { practice_code: this.patientpersonalinfo.practice_Code }, replaceUrl: true });
  }

  focusOutDate(e: any) {
    let date = e.target.value.split('-');
    if (date.length == 2) {
      if (Number(date[0]) < this.currentDate.getFullYear() || Number(date[1]) < Number(this.currentMonth)) {
        e.target.value = this.currentYear + '-' + this.currentMonth;
      }
    }

  }
  showCardInfoPopup() {
    $('#cardinfo-modal').modal('show');
  }
  SaveCardOnFile(event: Event): void {
    // Use event.target as HTMLInputElement to access the checked property
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    if (isChecked) {
      this.cardType = "existing_card";
      this.saveCard = "true";
      console.log('Checkbox is checked. Save Card on File is enabled.');
    } else {
      this.cardType = "";
      this.saveCard = "false";
      console.log('Checkbox is unchecked. Save Card on File is disabled.');
    }
  }
  getCardImage(cardType: string): string {
    switch (cardType.toLowerCase()) {
      case 'visa':
        return 'assets/images/payment/visa.png';
      case 'master card':
        return 'assets/images/payment/mastercard.png';
      case 'discover':
        return "assets/images/payment/discover.png";
      case 'amex':
        return "assets/images/payment/amercan.png";
      default:
        return 'assets/images/payment/default.png';
    }
  }
  isCardExpired(expMonth: string, expYear: string): boolean {
    const today = new Date();
    // Set expiration date to the last day of the given month
    const expirationDate = new Date(Number(expYear), Number(expMonth)); // Setting day as 0 gives last day of the previous month
    expirationDate.setDate(0); // Set to the last day of the month

    //console.log("today ", today);
    //console.log("expiry ", expirationDate);

    return today > expirationDate;
  }
  // Function to check if the card is expiring soon
  isCardExpiringSoon(expMonth: string, expYear: string): boolean {
    const today = new Date();
    const expirationDate = new Date(Number(expYear), Number(expMonth)); // Setting day as 0 gives last day of the previous month
    expirationDate.setDate(0);// Set to the last day of the month

    // Create a date for two month from now
    const twoMonthLater = new Date(today.getFullYear(), today.getMonth() + 2, today.getDate());
    // console.log("today ", today);
    // console.log("expiry soon ", expirationDate);
    // Check if the expiration date is after today but within the next month
    return expirationDate > today && expirationDate <= twoMonthLater;
  }
  deleteCardInfo(cardInfo: any) {
    const cardDetails = cardInfo;
    this.cardId = cardDetails.credit_card_id;
    this.cardToken = cardDetails.token_number;
    console.log("card token ", this.cardToken);
    $('#delete-creditcard').modal('show');
  }
  onConfirmDeleteCreditCard() {
    this.spinner.show();
    this.service.deleteCreditCardInfo(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account, this.cardId).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.statusCode == 200) {
        $('#delete-creditcard').modal('hide');
        let text = "Deleted successfully.";
        this.translateService.get('Alerts.psh_deleted_successfully').subscribe((translation: string) => {
          text = translation;
        });
        this.cardId = '';
        this.cardToken = '';
        this.phrUtils.showSuccess(text);
        this.getExistingCardDeatils();
      }
    }, (error) => {
      this.spinner.hide();
      this.cardId = '';
      this.cardToken = '';
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
    });
  }
  iscardSelected: boolean = false;
  cardHolderName: any;
  creditCardType: any;
  selectCard(e: any) {
    this.iscardSelected = true;
    console.log("event ", e);
    const cardDetails = e;
    this.creditCardType = cardDetails.card_type;
    // this.cardId = this.phrUtils.decryptforServices(cardDetails.credit_card_id);
    this.cardToken = this.phrUtils.encryptforServices(cardDetails.token_number);

    this.cardHolderName = cardDetails.credit_card_name;
    this.paymentForm.controls['dobMonth'].setValue(cardDetails.expiration_month);
    this.paymentForm.controls['dobyear'].setValue(cardDetails.expiration_year);
  }
  addNewCard() {
    this.isExistingcard = false;
    this.paymentForm.controls['dobMonth'].setValue("");
    this.paymentForm.controls['dobyear'].setValue("");
  }

}
